var React = require('react');

function Logo (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M159.45,85,132.86,40.57a1.51,1.51,0,0,0-1.29-.73h0l-47.49.26,23.6-35.78L122.6,29.26a1.5,1.5,0,1,0,2.57-1.54L109,.73A1.5,1.5,0,0,0,107.77,0h0a1.51,1.51,0,0,0-1.25.68L81.24,38.94,58.38.73A1.51,1.51,0,0,0,57.12,0a1.41,1.41,0,0,0-1.28.68L.25,85a1.48,1.48,0,0,0-.07,1.53,1.49,1.49,0,0,0,1.32.79H158.16a1.51,1.51,0,0,0,1.31-.76A1.49,1.49,0,0,0,159.45,85ZM54.93,84.28,72.85,57.12a1.5,1.5,0,0,0-2.51-1.65l-19,28.81H4.29L57,4.32l47.85,80Zm53.44,0L83.73,43.1l47-.25,24.8,41.43Z"})))]);
}

Logo.defaultProps = {"viewBox":"0 0 159.66 87.28"};

module.exports = Logo;

Logo.default = Logo;
